import { useI18n } from '../i18n/I18nContext';

export const LocalizedDocumentChrome = () => {
  const { t } = useI18n();
  return <a className="skip-link" href="#contenu">{t('app.skipToContent')}</a>;
};
